// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2jS3r","label":"Labeled_label__1Uh9D","divider":"Labeled_divider__1uzSU"};